import { render, staticRenderFns } from "./verificationCode.vue?vue&type=template&id=3449a6c2&scoped=true&"
import script from "./verificationCode.vue?vue&type=script&lang=js&"
export * from "./verificationCode.vue?vue&type=script&lang=js&"
import style0 from "./verificationCode.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./verificationCode.vue?vue&type=style&index=1&id=3449a6c2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3449a6c2",
  null
  
)

component.options.__file = "verificationCode.vue"
export default component.exports